import type { RobotModelForLiveMap } from 'app/modules/machine-inventory/machine-details-panel/state/machineDetailsPanelRobot/liveMap/liveMapActions.types';
import type { MapFeatures } from 'app/modules/machine-inventory/machine-details-panel/components/MachineDetailsRobotPanel/MachineDetailsRobotSchedule/types/MapArea.types';
import kiraB50Icon from 'lib/assets/images/icons/KIRA_B50.png';
import kiraCv50Icon from 'lib/assets/images/icons/KIRA_CV50_Icon.svg';

// KIRA_B50.png already points 90° clockwise from +x; the round CV50 icon needs no offset.
export const LIVE_POSITION_ICON_BASE_ROTATION_DEG: Record<RobotModelForLiveMap, number> = { B50: 90, CV50: 0 };

// The B50 robot covers only ~13x17px of its 30px image, leaving the glow visible; CV50 is sized to match.
export const LIVE_POSITION_ICON_SIZE_PX: Record<RobotModelForLiveMap, number> = { B50: 52, CV50: 30 };

export const LIVE_POSITION_ICON_SRC: Record<RobotModelForLiveMap, string> = { B50: kiraB50Icon, CV50: kiraCv50Icon };

export const EMPTY_MAP_FEATURES: MapFeatures = {
  startPoints: [],
  specialZones: [],
  noGoAreas: [],
  noGoLines: [],
  glassLines: [],
};
